<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Richiesta profilo"></app-toolkit-page-title>
            <div class="card">
                <div class="card-body">
                    <p>Al momento la sua utenza non è abilitata ad accedere al portale "<strong>{{ appName }}</strong>". Può richiedere l'abilitazione compilando il form sottostante.</p>
                    <form class="form" role="form" [formGroup]="formGroup" (ngSubmit)="submitForm()">
                        <app-toolkit-utente-form-utente [formGroup]="formGroup" [datalist]="datalist"></app-toolkit-utente-form-utente>
                        <p class="mt-3"><strong>* Campi obbligatori.</strong></p>
                        <div class="button-actions">
                            <button type="submit" class="btn btn-primary">Invia</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>